import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#FC0",
  d: "M7.134 1.5a1 1 0 0 1 1.732 0l6.928 12a1 1 0 0 1-.866 1.5H1.072a1 1 0 0 1-.866-1.5z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#1F1F1F",
  d: "M8.627 4.945q.147 0 .21.076.064.075.05.241l-.361 4.17q-.031.369-.629.369-.596 0-.628-.368l-.362-4.17q-.012-.165.051-.242.063-.075.21-.076zm-.73 5.96q.52 0 .75.096.234.088.234.304v1.359q0 .215-.235.31-.228.09-.749.09-.52 0-.755-.09-.228-.095-.228-.31v-1.359q0-.216.228-.304.235-.096.755-.096"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }